<app-grid #orignRef [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
  (refreshDataFromServer)="refreshData($event)" (rowSelected)="rowSeleceted($event)"
  (addClicked)="addCategory(orignRef)" (editClicked)="editCategory(orignRef)"
  (deleteClicked)="deleteCategory()" [gridName]="'examinationCategoryGrid'"></app-grid>